import { Box } from "@dropbox/dig-foundations";
import { UIIcon } from "@dropbox/dig-icons";
import { CheckmarkCircleLine } from "@dropbox/dig-icons/assets";
import { useMirageAnalyticsContext } from "@mirage/analytics/AnalyticsProvider";
import type { DashSetupModule } from "@mirage/analytics/events/enums/dash_setup_module";
import { PAP_Hide_DashSetupModule } from "@mirage/analytics/events/types/hide_dash_setup_module";
import { showSnackbar } from "@mirage/shared/snackbar";
import React, { useCallback } from "react";
import styles from "../styles.module.css";

export const useOnHideClick = (module: DashSetupModule) => {
  const { reportPapEvent } = useMirageAnalyticsContext();

  const onHideClick = useCallback(
    (message: React.ReactNode) => {
      reportPapEvent(
        PAP_Hide_DashSetupModule({
          dashActionSurface: "setup_module",
          actionSurfaceComponent: "setup_module",
          featureLine: "onboarding",
          dashSetupModule: module,
        }),
      );

      showSnackbar({
        title: (
          <Box className={styles.gap8} display="flex" alignItems="center">
            <UIIcon src={CheckmarkCircleLine} />
            <div>{message}</div>
          </Box>
        ),
        hideCloseButton: true,
      });
    },
    [module, reportPapEvent],
  );

  return onHideClick;
};
